import * as _ from "lodash";
import { getToken } from 'chaos-sso-util'
export default {
  /**
   * 数组转为树结构
   * @param arr
   * @param node
   */
  arr2tree(arr, node) {
    let children = arr.filter(item => item.pid == node.id);
    if (children && children.length) {
      node.children = children;
      for (let cNode of children) {
        this.arr2tree(arr, cNode);
      }
    } else {
      delete node.children
    }
  },

  /**
   * 树结构转数组
   * @param node
   * @param arr
   */
  tree2arr(node,arr){
    let children = node.children;
    if(!!children && children.length){
      for (let cNode of children) {
        this.tree2arr(cNode,arr);
      }
      delete node.children;
    }
    arr.push(node);
  },

  /**
   * 遍历更新树的节点
   * @param node 树节点
   * @param arr  选中的数组
   */
  checkNode(node, arr) {
    if (!!node.children && node.children.length) {
      let children = node.children;
      for (let child of children) {
        this.checkNode(child, arr);
      }
    }
    let apply = arr.find(item => node.id == item.skillId);
    if (!!apply) {
      node['applyId'] = 1;
      node['skillLevel'] = apply.skillLevel;
      node['applyTime'] = apply.applyTime;
      node['adoptTime'] = apply.adoptTime;
    }
  },

  /**
   * 遍历技能树，根据节点id，返回关联的父节点id
   * @param nodeId  节点id
   * @param arr 全量树（平铺数组）
   * @param parentIds
   */
  getParentIds(nodeId, arr, parentNodes) {
    let node = arr.find(item => item.id == nodeId);
    if (!!node) {
      this.getParentIds(node.pid, arr, parentNodes);
      parentNodes.push(node);
    }
  },

  /**
   * 获取关联的技能节点
   * @param skillId
   * @returns {Array}
   */
  getRelativeSkillIds(skillId) {
    let skills = [];
    let relativeSkills = [];
    try {
      let skillStr = window.localStorage.getItem('skills');
      if (!!skillStr) {
        skills = JSON.parse(skillStr);
      }
      this.getParentIds(skillId, skills, relativeSkills);
      return relativeSkills;
    } catch (error) {
      return [];
    }
  },

  /**
   * 树的过滤功能实现
   * 1、将树平铺展开为数组
   * 2、数组过滤关键字，是否需要包含子呢
   * 3、重新将数组组合成树结构
   */
  filterTrees(searchKey,searchField,trees){
    if(searchKey === '' || searchKey == null || searchKey == undefined){
      return trees;
    }
    let copyTrees = _.cloneDeep(trees);//隔离操作数据
    //1、平铺展开
    let all = [];
    for(let treeNode of copyTrees){
      let nodeArr = [];
      this.tree2arr(treeNode,nodeArr);
      all = all.concat(nodeArr);
    }
    //2、模糊搜索过滤,不区分大小写,包含子
    let upperSearchKey = searchKey.toUpperCase();
    let searchArr = all.filter(item => {
      let valid = false;
      let nodeName = item[searchField];
      if(!!nodeName && typeof nodeName == 'string'){
        valid = nodeName.toUpperCase().indexOf(upperSearchKey) > -1;
      }
      return valid;
    });
    let copySearchArr = _.cloneDeep(searchArr);
    for(let sNode of copySearchArr){
      let children = [];
      this.getAllChildren(sNode.id,all,children);
      let uniqueChildren = children.filter(item => !searchArr.find(node => node.id == item.id));
      searchArr = searchArr.concat(uniqueChildren);
    }
    //3、重新组合
    let filterTrees = [];
    let firstNodes = searchArr.filter(node => !searchArr.find(item => item.id == node.pid));
    for (let fNode of firstNodes) {
      this.arr2tree(searchArr, fNode);
      filterTrees.push(fNode);
    }
    return filterTrees;
  },

  //getAllChildren
  getAllChildren(pid,all,children){
    let cNodes = all.filter(item => item.pid == pid);
    if(!!cNodes && cNodes.length){
      for(let cNode of cNodes){
          this.getAllChildren(cNode.id,all,children);
          children.push(cNode);
      }
    }
  },

  // 组装技术名称
  getSkillName(item){
    return [item['skill1'],item['skill2'],item['skill3'],item['skill4']].join(" >> ");
  },

  downloadByUrl(url, fileName) {
    // 解决sso单点认证问题
    // console.log('token:', getToken());
    var xhr = new XMLHttpRequest();
    var formData = new FormData();
    xhr.open('get', url); //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
    xhr.setRequestHeader(process.env.VUE_APP_SSO_HEADER_TOKEN, getToken());
    xhr.responseType = 'blob';
    xhr.onload = function(e) {
      if(!fileName) {
        const disposition = xhr.getResponseHeader('content-disposition')
        fileName = disposition.substring(disposition.lastIndexOf('=') + 1)
        fileName = decodeURI(fileName)
      }
      if (this.status == 200) {
        var blob = this.response;
        // console.log(this.response)
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var a = document.createElement('a');
          var url = URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        }
      }
    };
    xhr.send(formData);
  }

}




// WEBPACK FOOTER //
// ./src/utils/util.js